var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigureGreen208F2Bef59008B98A11A42Ce24590247(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.667 21C12.667 17.6863 15.3533 15 18.667 15C21.9807 15 24.667 17.6863 24.667 21C24.667 24.3137 21.9807 27 18.667 27C15.3533 27 12.667 24.3137 12.667 21ZM18.667 9C12.0396 9 6.66699 14.3726 6.66699 21C6.66699 27.6274 12.0396 33 18.667 33C24.2667 33 28.9706 29.1644 30.2948 23.9771C30.4167 23.9922 30.541 24 30.667 24H60.667C62.3238 24 63.667 22.6569 63.667 21C63.667 19.3431 62.3238 18 60.667 18H30.667C30.541 18 30.4167 18.0078 30.2948 18.0229C28.9706 12.8356 24.2667 9 18.667 9ZM9.66699 48C8.01014 48 6.66699 49.3431 6.66699 51C6.66699 52.6569 8.01014 54 9.66699 54H39.667C39.793 54 39.9172 53.9922 40.0392 53.9771C41.3633 59.1644 46.0672 63 51.667 63C58.2944 63 63.667 57.6274 63.667 51C63.667 44.3726 58.2944 39 51.667 39C46.0672 39 41.3633 42.8356 40.0392 48.0229C39.9172 48.0078 39.793 48 39.667 48H9.66699ZM51.667 45C48.3533 45 45.667 47.6863 45.667 51C45.667 54.3137 48.3533 57 51.667 57C54.9807 57 57.667 54.3137 57.667 51C57.667 47.6863 54.9807 45 51.667 45Z",
    fill: "#2DC8C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.667 21C12.667 17.6863 15.3533 15 18.667 15C21.9807 15 24.667 17.6863 24.667 21C24.667 24.3137 21.9807 27 18.667 27C15.3533 27 12.667 24.3137 12.667 21ZM18.667 9C12.0396 9 6.66699 14.3726 6.66699 21C6.66699 27.6274 12.0396 33 18.667 33C24.2667 33 28.9706 29.1644 30.2948 23.9771C30.4167 23.9922 30.541 24 30.667 24H60.667C62.3238 24 63.667 22.6569 63.667 21C63.667 19.3431 62.3238 18 60.667 18H30.667C30.541 18 30.4167 18.0078 30.2948 18.0229C28.9706 12.8356 24.2667 9 18.667 9ZM9.66699 48C8.01014 48 6.66699 49.3431 6.66699 51C6.66699 52.6569 8.01014 54 9.66699 54H39.667C39.793 54 39.9172 53.9922 40.0392 53.9771C41.3633 59.1644 46.0672 63 51.667 63C58.2944 63 63.667 57.6274 63.667 51C63.667 44.3726 58.2944 39 51.667 39C46.0672 39 41.3633 42.8356 40.0392 48.0229C39.9172 48.0078 39.793 48 39.667 48H9.66699ZM51.667 45C48.3533 45 45.667 47.6863 45.667 51C45.667 54.3137 48.3533 57 51.667 57C54.9807 57 57.667 54.3137 57.667 51C57.667 47.6863 54.9807 45 51.667 45Z",
    fill: "url(#paint0_linear_272_2949)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_272_2949",
    x1: 51.0979,
    y1: -66.0384,
    x2: -48.3041,
    y2: 19.0428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206376,
    stopColor: "#FFF0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359714,
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833386,
    stopColor: "#FF41F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF33FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigureGreen208F2Bef59008B98A11A42Ce24590247);
export default __webpack_public_path__ + "static/media/configure-green.208f2bef59008b98a11a42ce24590247.c0a1a983303b5e47854cdb6eb021d475.svg";
export { ForwardRef as ReactComponent };